import { Images } from "@/utils/Images"
import Image from "next/image"


export default function Oink() {
    return <Image src={Images.oinkhub.Oink} alt="Oink" width={24} height={24} />
}